import List from 'list.js';

export function exhibitors() {
  const list = document.getElementById('archive-exhibitors');
  if(list) {
    const exhibitorsList = new List('archive-exhibitors', { 
      valueNames: [
        { name: 'booth', attr: 'data-name' },
        { name: 'number', attr: 'data-name' },
        { name: 'area', attr: 'data-name' },
        { name: 'name', attr: 'data-name' }
      ]
    });

    // const updatedList = function(e) {

    // }

    exhibitorsList.sort('name', { order: "asc" }); 
    // exhibitorsList.on('updated', updatedList);
  }
}